import { __read } from 'tslib';
import React, { useState } from 'react';
import { ArrowIcon2 } from '../../../../components/ArrowIcon/index.js';
import cx from 'classnames';

var prefix = 'collapse-menu';
var CollapseMenu = function CollapseMenu(_a) {
  var _b;
  var title = _a.title,
    children = _a.children;
  var _c = __read(useState(false), 2),
    isOpen = _c[0],
    setIsOpen = _c[1];
  var toggleMenu = function toggleMenu() {
    setIsOpen(!isOpen);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(prefix, (_b = {}, _b["".concat(prefix, "--open")] = isOpen, _b))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-title"),
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement(ArrowIcon2, null)), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content")
  }, children));
};

export { CollapseMenu as default };
